import styled from 'styled-components';
import {
  gridGap,
  GridProps,
  justifyContent,
  JustifyContentProps,
  layout,
  LayoutProps,
  variant,
} from 'styled-system';
import themeUtilities from '../../../../../theme/ThemeUtilities';
import { Size } from '../../types';

export const StyledTableCell = styled.div<
  { cellSize?: Size } & JustifyContentProps & LayoutProps & GridProps
>`
  display: flex;
  flex: 1;
  align-items: center;
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'cell'))};
  ${justifyContent};
  ${layout};
  ${gridGap};
`;
StyledTableCell.defaultProps = {
  cellSize: 'regular',
  minWidth: 120,
};
